import { RootState } from "../../../store/reducers";
import styles from "./ReportOverview.module.scss";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Loader from "../../loader";
import { numberFormatter } from "../../../utilities/numberFormatter";
import { useTranslation } from "react-i18next";

export const ReportOverview = () => {
  const { t } = useTranslation();
  const [reportOverviewData, SetReportOverviewData] = useState<any>({});
  const { reportOverview, isReportOverviewLoading } = useSelector(
    (state: RootState) => {
      return state.filters;
    }
  );

  useEffect(() => {
    SetReportOverviewData(reportOverview);
  }, [reportOverview]);

  return (
    <div className={styles.reportOverviewWrapper}>
      <div className={styles.reportOverviewHeader}>
        {t("pa.reportOverview")}
      </div>
      <div className={styles.reportOverviewBody}>
        <div className={styles.reportOverviewContent}>
          {isReportOverviewLoading && <Loader />}
          <div className={styles.overviewSection}>
            <div className={styles.reviewCount}>
              {numberFormatter(
                reportOverviewData?.jobRoleFeedback?.numberOfIncumbentsMarket
              )}
            </div>
            <div className={styles.reviewCountLabel}>
              {t("pa.reportOverview.IncumbentsInMarket")}
            </div>
          </div>
          <div className={styles.overviewSection}>
            <div className={styles.reviewCount}>
              {numberFormatter(
                reportOverviewData?.jobRoleFeedback?.numberOfOrganizationsMarket
              )}
            </div>
            <div className={styles.reviewCountLabel}>
              {t("pa.reportOverview.OrganizationsInMarket")}
            </div>
          </div>
          {/* <div className={styles.reviewCount}>
            {numberFormatter(
              reportOverviewData?.jobRoleFeedback
                ?.numberOfIncumbentsOrganization
            )}
          </div>
          <div className={styles.reviewCountLabel}>
            {t("pa.reportOverview.IncumbentsInOrganization")}
          </div> */}
        </div>
      </div>
    </div>
  );
};
